<template>
  <transition name="up-fade">
    <div v-if="showDialog" class="up-overlay" @click.self="dismiss">
      <div class="up-card">
        <div class="up-header">
          <svg class="up-icon" viewBox="0 0 24 24" width="28" height="28" fill="#1a73e8">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
          </svg>
          <span class="up-title">{{ $t('pwa.updateTitle') }}</span>
        </div>
        <p class="up-message">{{ $t('pwa.updateMessage') }}</p>
        <div class="up-actions">
          <button class="up-btn up-btn-later" @click="dismiss">{{ $t('pwa.updateLater') }}</button>
          <button class="up-btn up-btn-update" @click="applyUpdate">{{ $t('pwa.updateNow') }}</button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'UpdatePrompt',
  data () {
    return {
      showDialog: false,
      registration: null
    }
  },
  mounted () {
    document.addEventListener('swUpdated', this.handleSWUpdate)
  },
  beforeDestroy () {
    document.removeEventListener('swUpdated', this.handleSWUpdate)
  },
  methods: {
    handleSWUpdate (event) {
      this.registration = event.detail
      this.showDialog = true
    },
    dismiss () {
      this.showDialog = false
    },
    applyUpdate () {
      this.showDialog = false
      if (this.registration && this.registration.waiting) {
        this.registration.waiting.postMessage({ type: 'SKIP_WAITING' })
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          window.location.reload()
        })
      } else {
        window.location.reload()
      }
    }
  }
}
</script>

<style scoped>
.up-overlay {
  position: fixed;
  inset: 0;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.4);
}

.up-card {
  background: #fff;
  border-radius: 10px;
  width: 90%;
  max-width: 340px;
  padding: 24px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);
}

.up-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.up-title {
  font-size: 17px;
  font-weight: 600;
  color: #333;
}

.up-message {
  font-size: 14px;
  color: #666;
  line-height: 1.5;
  margin-bottom: 20px;
}

.up-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.up-btn {
  padding: 8px 18px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s ease;
}

.up-btn-later {
  background: #f0f0f0;
  color: #666;
}

.up-btn-later:hover {
  background: #e4e4e4;
}

.up-btn-update {
  background: #1a73e8;
  color: #fff;
}

.up-btn-update:hover {
  background: #1557b0;
}

.up-fade-enter-active,
.up-fade-leave-active {
  transition: opacity 0.25s ease;
}

.up-fade-enter,
.up-fade-leave-to {
  opacity: 0;
}
</style>
